const TopNavigation=({navigate,x})=>{
  return (
    <div style={{position:'absolute',display:'flex',flexDirection:'row',width:'100%',height:window.innerHeight*window.barSize,textAlign:'center',justifyContent:'space-evenly'}}>
      <button
      style={{display:'flex',width:'100%',height:'100%'}}
      onClick={()=>{navigate('Start')}}>
        <div
        style={{display:'flex',color:x==0?'white':'silver',background:0}}>
          ANA SAYFA
        </div>
      </button>
      <button
      style={{display:'flex',width:'100%',height:'100%'}}
      onClick={()=>{navigate('Products')}}>
        <div
        style={{display:'flex',color:x==100?'white':'silver',background:0}}>
          ÜRÜNLER
        </div>
      </button>
      <button
      style={{display:'flex',width:'100%',height:'100%'}}
      onClick={()=>{navigate('Contact')}}>
        <div
        style={{display:'flex',color:x==200?'white':'silver',background:0}}>
          İLETİŞİM
        </div>
      </button>
    </div>
  );

}

export default TopNavigation;
